 <template>
  <div class="ModalComentariosByCampo">
    <!-- Dialogo con comentarios -->
    <v-dialog
      v-model="showDialogocomentarios"
      scrollable
      persistent
      width="50%"
    >
      <template v-slot:activator="{ on, attrs }">
					<a
					class="px-2 btn-link d-inline-block"
					v-bind="attrs" v-on="on"
					@click="eventClickComentario">
						Añadir comentario sobre esta documentación
					</a>
					<!--<v-btn icon small color="rgb(18, 77, 145)" v-bind="attrs" v-on="on" @click="eventClickComentario">
							<v-icon>mdi-comment-outline</v-icon>
					</v-btn>-->
					<v-badge		
					class="pl-2"
					color="rgb(18, 77, 145)" 
					:content="comentarios.length.toString()" />
      </template>
      <v-card>
        <v-card-title> 
          <span class="col-12">Añadir comentario al campo '{{campo.titulo}}'</span>
          <v-row class="my-2 mx-0" justify="end">
            <v-textarea class="col-12 text-body-1" rows="3" 
              :rules="[validationRules.maxLength(observacion, 2000)]"
              counter="2000"
              v-model="observacion"
              outlined
              autofocus />
            <v-btn small color="primary" class="mt-2" :disabled="!observacion.trim() || observacion.length > 2000" @click="eventClickNuevo">
              Añadir
            </v-btn>
          </v-row>
        </v-card-title>
        <!-- Este componente no permite focus en textArea la primera vez que se crea -->
        <v-card-text>
          <ListaComentarios :campo="campo" :comentarios="comentarios" :habilitarCRUD="true" @reload="eventReload" />
        </v-card-text>

        <v-card-actions class="gap-3">
          <v-spacer></v-spacer>
          <v-btn
            color="rgb(18, 77, 145)"
            text
            class="text-decoration-underline"
            @click="eventClickVolver"
          >
            Cerrar
          </v-btn>      
        </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@Base/services/auditoriaService';
import ListaComentarios from "./ListaComentarios.vue";
import StepBase from '@Base/pages/common/StepBase.js';

export default {
  name: 'ModalComentariosByCampo',
  mixins: [StepBase],
  components: {
    ListaComentarios
  },
  props: ['campo'],
  watch: {
		$props:  {
      handler() {
				this.getComentarios();
      },
      immediate: true,
    }
	},
  data () {
    return {
			showDialogocomentarios: false,
			observacion: "",
			comentarios: []
		}
	},
  computed: {
  },
  methods:{
    // Evento click del botón añadir
    eventClickNuevo() {
      let payload = {
        campo: this.campo.id,
        expediente: this.campo.idSolicitud,
				fecha: new Date().getTime(),
        observacion: this.observacion,
				nif: this.$store.state.solicitud.solicitante.dni
      };
      
			api.crearComentarioDeCampo(payload,
      res => {
        this.getComentarios();
        this.clearData();
      },
			err => {
			});
    },
    // Evento click del boton volver
    eventClickVolver() {
      this.showDialogocomentarios = false;
      this.clearData();
      this.$emit('reload', this.campo.categoria);
    },
    clearData() {
      this.observacion = "";
    },
    getComentarios() {
      api.obtenerComentariosDeCampo(this.campo.idSolicitud, this.campo.id,
			res => {        
        this.comentarios = res;
        this.$forceUpdate();
      },
			err => {
			});
    },
    eventClickComentario() {
      //this.getComentarios();
    },
    eventReload() {
      this.getComentarios();
    },
  },

}
</script>

<style>
</style>